import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Observable } from "rxjs/Observable";

import { AppService } from "./services/app.service";
import { HeaderService } from "./services/header.service";
import { SessionTimeoutService } from "./services/session-timeout.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html"
})
export class AppComponent implements OnInit, OnDestroy {
  public loading: boolean = true;
  showFooter = false;
  public timer: any;
  constructor(
    private router: Router,
    public appService: AppService,
    public headerService: HeaderService,
    public sessionTimeoutService: SessionTimeoutService
  ) { }

  ngOnInit() {
    this.appService.getUserProfile().then(user => {
      sessionStorage.setItem("loggedInUserRole", user.role);
      sessionStorage.setItem("loggedInUser", user.loggedInUser);
      if (this.router.url === "/") {
        if (!user.isRoleGlobal()) {
          if (user.isBusinessAccount()) {
            this.router.navigate(["/organization"]);
          } else {
            this.goToSysError();
          }
        } else if (user.role === "ACCMGR") {
          this.router.navigate(["/accmgr"]);
        } else if (user.role === "ACCINTCONS") {
          this.router.navigate(["/intconslanding"]);
        } else if (user.role === "ACCSUPPORT") {
          this.router.navigate(["/intsuplanding"]);
        } else if (user.role === "Internal") {
          this.goToSysError();
        }
      }
      this.loading = false;
    }).catch(e => {
      this.loading = false;
    });
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // Listen to router events to reload the footer after each route change
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showFooter = false;
        this.loadFooter(event);
      }
    });

    this.sessionTimeoutService.SessionTimeout.subscribe(val => {
      if (val) {
        document.getElementById("sessionModal").style.display = "block";
      }
    });
    this.checkSessionTimeOut();
  }
  
  loadFooter(event: NavigationEnd): void {
    if (event.urlAfterRedirects === '/reqHistory') {
      this.showFooter = false;
    } else {
      setTimeout(() => {
        this.showFooter = true;
      }, 2000);
    }
  }

  ngOnDestroy() { }

  goToSysError() {
    this.router.navigate(["/sysError"]);
  }

  checkSessionTimeOut() {
    this.setTimer();
    document.getElementsByTagName("body")[0].addEventListener("click", () => {
      clearTimeout(this.timer);
      this.setTimer();
    });
  }
  setTimer() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      document.getElementById("sessionModal").style.display = "block";
    }, 900000);
  }

  public resetTimer() {
    document.getElementById("sessionModal").style.display = "none";
    this.setTimer();
  }

  public getProfile() {
    return Observable.forkJoin(this.appService.getUserProfile());
  }

  public closeWindow() {
    window.close();
  }
}



// WEBPACK FOOTER //
// ./client/views/app.component.ts